module.exports = __webpack_public_path__ + "static/media/greyCheck.c106f72d.svg";